import React from "reactn"
import { graphql, Link } from "gatsby"
import { Box, Heading, Text } from "@chakra-ui/react"
import { GatsbyImage } from "gatsby-plugin-image"

export function StoryCard({ story, eager, location }) {
  const {
    name,
    slug
  } = story
  const {
    image,
    subtitle,
    text
  } = story.sections[0].rows[0]
  const {
    pathname
  } = location
  console.log("story", story)
  return (
    <Box className="story-container" w={'100%'}>
      <Link to={`${pathname}/${slug}`} alt={name} >
        <Box maxW={'300'}>
        <GatsbyImage 
          image={image.gatsbyImageData}
          loading={eager ? "eager" : "lazy"}
          alt={name} />
          </Box>
        <Box maxW={'300px'}>
          <Heading variant={'storyHeading'} align={'center'} >
            {name}
          </Heading>
          <Text variant={'story'} align={'center'} >{subtitle}</Text>

        </Box>
      </Link>
    </Box >
  )
}

export const query = graphql`
  fragment StoryCard on DatoCmsStory  {
    id
    name
    slug
    sections {
      ... on DatoCmsSection {
        rows {
          ... on DatoCmsBlock {
            ...StorySummaryBlockCard            
          }
        }
      }
    }
  }
`
